//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { omit, filter } from 'lodash';


//  -- Actions ------------------------
import * as ClassActions from './actions';
import { map, flatMap } from 'lodash';
import { captureException} from "@sentry/react";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create class -------------------
export const handleCreateClass = (data, userBooks) => async (dispatch) => {
    await dispatch(ClassActions.createClass());

    try {
        const classData = await apis.post('classesRDS', `/classes`, {
            body: { ...data }
        });
        if (userBooks.books_group.length > 0 && classData.id) {
            userBooks.userId = classData.id;
            await apis.post('userBooksRDS', `/userBooks`, {
                body: userBooks
            });
        }
        if (classData.id) {
            await dispatch(ClassActions.createClassSuccess(classData));
        }
        return classData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`177 Error in class creation: ${error}`);
        }
        await dispatch(ClassActions.createClassFail(error));
    }
};

//  -- Get class ----------------------
export const handleGetClass = (classID) => async (dispatch) => {
    await dispatch(ClassActions.getClass());
    sessionStorage.setItem("LastActiveclassID", classID)
    if (!classID) return;
    try {
        let classData = {}
        const classWithBook = await apis.get('classesRDS', `/getCurrentClass/${classID}`);
        if (classWithBook && !classWithBook.error) {
            classData = classWithBook;
        }

        await dispatch(ClassActions.getClassSuccess(classData));
        return classData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`178 Error in getting class: ${error}`);
        }
        await dispatch(ClassActions.getClassFail(error));
    }
};

//  -- Get class by code --------------
export const handleGetClassByCode = (code) => async (dispatch) => {
    await dispatch(ClassActions.getClassByCode());

    try {
        const classData = await apis.get('classesRDS', `/classByCode/${code}`);
        if (classData && !classData.error) {
            const books = await apis.get('userBooksRDS', `/userBooksByUser/${classData?.id}`);
            let filterBooks = omit(books, ['id']);
            await dispatch(ClassActions.getClassByCodeSuccess('Success'));
            return {
                ...classData,
                ...filterBooks
            }
        }
        else {
            return null;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`825 Error getting class by code: ${error}`);
        }
        await dispatch(ClassActions.getClassByCodeFail(error));
    }
};



//  -- Get organization classes -------
export const handleGetOrgClasses = (orgs) => async (dispatch) => {
    // await dispatch(ClassActions.listOrgClasses());
    let classDataBook = [];

    try {
        if (orgs && orgs.length > 0) {
            const orgData = await apis.post('classesRDS', `/classesByOrgs`, {
                body: {
                    orgs: map(orgs, org => org.id)
                }
            });
            if (Array.isArray(orgData) && orgData.length > 0) {
                classDataBook = orgData;
            }
        }
        await dispatch(ClassActions.listOrgClassesSuccess(classDataBook));
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`826 Error getting organization classes: ${error}`);
        }
        await dispatch(ClassActions.listOrgClassesFail(error));
    }
};

//  -- Get organization courses (Class) only for active canvas dist -------
export const handleGetOrgCanvasCourses = (current_org) => async (dispatch) => {
    // await dispatch(ClassActions.listOrgClasses());
    let classDataBook = [];

    try {
        if (current_org) {
            const orgData = await apis.post('classesRDS', `/getCanvasCourses`, {
                body: {
                    orgId:current_org
                }
            });
            if (Array.isArray(orgData) && orgData.length > 0) {
                classDataBook = orgData;
            }
            return classDataBook;
        }
        // await dispatch(ClassActions.listOrgClassesSuccess(classDataBook));
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`827 Error getting organization canvas courses: ${error}`);
        }
        await dispatch(ClassActions.listOrgClassesFail(error));
    }
};

// ----Archived/Active courses (Class) only for active canvas dist------
export const handleArchiveCanvasCourse = (canvasId, status) => async (dispatch) => {
    if (canvasId) {
        try {
            const enableUser = await apis.post("classesRDS", "/ArchiveCanvasCourses", {
                body: {
                    status: status,
                    canvasId: canvasId
                }
            })
            if(enableUser&&enableUser.id){
                // await dispatch(UsersActions.userEnableSuccess(enableUser))
            }
            return enableUser;
        } catch (error) {
            if (error && error.message != "Network Error") {
                captureException(`828 Error archiving canvas course: ${error}`);
            }
            // return await dispatch(UsersActions.userEnableFail(error));
        }
    }
}

//  -- List teacher classes -----------
export const handleListTeacherClasses = (teacherID) => async (dispatch) => {
    await dispatch(ClassActions.listTeacherClasses());

    try {
        let classes = []
        const classesRDS = await apis.get('classesRDS', `/classesByTeacher/${teacherID}`);
        if (classesRDS && !classesRDS.error) {
            classes = classesRDS;
        }
        await dispatch(ClassActions.listTeacherClassesSuccess('Succeses'));
        return classes;
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`829 Error listing teacher classes: ${error}`);
        }
        await dispatch(ClassActions.listTeacherClassesFail(error));
    }
};

//  -- Update class -------------------
export const handleUpdateClass = (classID, data, booksUser, userBookId) => async (dispatch) => {
    await dispatch(ClassActions.updateClass());

    try {
        await apis.put('classesRDS', `/classes/${classID}`, {
            body: { ...data }
        });
        if (booksUser && booksUser.books_group.length > 0) {
            booksUser.userId = classID;
            await apis.put('userBooksRDS', `/userBooks/${userBookId}`, {
                body: booksUser
            });
        }
        await dispatch(ClassActions.updateClassSuccess(data));
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`178 Error in class update: ${error}`);
        }
        await dispatch(ClassActions.updateClassFail(error));
    }
};

//  -- Username check -----------------
export const handleCheckCode = (code) => async () => {
    try {
        const classes = await apis.get('classesRDS', `/classByCode/${code}`);
        if (classes && classes.error) {
            return false;
        } else {
            return classes ? classes : false;
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`830 Error checking code: ${error}`);
        }
        console.log(error);
    }
};



export const handleDeleteClassData = (classId) => async (dispatch) => {
    try {
        await apis.del('classesRDS', `/classesData/${classId}`);
    } catch (error) {
        if (error && error.message != "Network Error") {
            captureException(`179 Error in class deletion: ${error}`);
        }
    }
};




//  -- List all teacher from classes -----------
export const handleListAllTeacherFromClass = (classId) => async (dispatch) => {
    try {
        if(!classId) return []
        let classes = []
        const classesRDS = await apis.get('classesRDS', `/getCoTeacher/${classId}`);
        if (classesRDS && !classesRDS.error) {
            classes = classesRDS;
        }
        const classIds = classes.map(item => item.userId);
        await dispatch(ClassActions.getClassAllTeacherSuccess(classIds));
        return classIds;
    } catch (error) {
        console.error(error);
        return [];
    }
};
export const handleListClassSyncStatus =  async(user_id) => {
    try {
        if(!user_id) return null;
        const classesRDS = await apis.get('classesRDS', `/list_sync_status_by_user/${user_id}`);
        return classesRDS;
    } catch (error) {
        console.error(error);
        return ({
            error: "Failed to fetch sync status"
        });
    }
};
export const handleUpdateClassSyncStatus =  async(data) => {
    try {
        const classesRDS = await apis.post('classesRDS', `/update_sync_status`,{
            body:data
        });
        return classesRDS;
    } catch (error) {
        console.error(error);
        return ({
            error: "Failed to fetch sync status"
        });
    }
};
